import { 
  IonButton, IonCol, IonContent, IonButtons, IonCard, IonicSlides, IonImg, 
  IonCardHeader, IonCardTitle, IonTitle, IonGrid, IonHeader, IonLabel, 
  IonList, IonItem, IonNote, IonRow, IonToolbar, IonPopover, IonIcon 
} from '@ionic/react';
import React, { useEffect, useState, useRef } from 'react';
import { 
  globeOutline, locationSharp, phonePortraitOutline, 
  playOutline, pauseOutline, stopOutline, volumeHighOutline 
} from 'ionicons/icons';

import { 
  cash, earth, medal, time, calendar, business, sparkles, flag, compass, 
  image, map, images, accessibility, construct, bulb, ribbon, alarmSharp, linkSharp
} from 'ionicons/icons';

import { ParaderoTrenMaya } from '../interfaces';
import './MarkerInfoWindow.css'

import { Swiper, SwiperSlide } from 'swiper/react';

// Import Swiper styles
import 'swiper/css';
import 'swiper/css/pagination';
import 'swiper/css/navigation';

import closePage from '../assets/close-circle.svg'
import location_white from '../assets/location-pin.svg'

// import required modules
import { Autoplay, Keyboard, Pagination, Scrollbar, Zoom } from 'swiper';

import { useTranslation } from 'react-i18next';

import mxproficon from '../assets/logo.svg';
import cooperativa from '../assets/cooperativa-circle.svg';
import comidatipica from '../assets/molcajete-circle.svg';
import arqueolo from '../assets/piramide-circle.svg';
import chac from '../assets/chac-circle.svg';

const EstacionTrenModal = ({
  marker,
  onDismiss,
}: {
  marker: ParaderoTrenMaya;
  onDismiss: () => void;
}) => {
  useEffect(() => {
    console.log(`../assets/imgCorredor/${marker.image1}`);
  }, []);
  
  const re = new RegExp("https://");
  const [t, i18n] = useTranslation("global");
  const [speechStatus, setSpeechStatus] = useState<'stopped' | 'playing' | 'paused'>('stopped');
  const utteranceRef = useRef<SpeechSynthesisUtterance | null>(null);

  console.log('Language: ', i18n.language);

  const langEnable = i18n.language;
  const [selectedLang, setSelectedLang] = React.useState("es-ES");

  let langfront = '';

  switch (langEnable) {
    case 'es':
      langfront = "es-MX";
      break;
    case 'en':
      langfront = "en-US";
      break;
    case 'fr':
      langfront = "fr-FR";
      break;
    case 'zh':
      langfront = "zh-CN";
      break;
    case 'maya':
      langfront = "yua";
      break;
  }

  const handleSpeech = () => {
    const synth = window.speechSynthesis;
    let utter;
    
    switch (speechStatus) {
      case 'stopped':
        // Crear nueva instancia de reproducción
        utter = new SpeechSynthesisUtterance(marker.descripcion);
        utter.lang = langfront === 'yua' ? 'es-MX' : langfront;
        
        utter.onend = () => {
          setSpeechStatus('stopped');
          utteranceRef.current = null;
        };
        
        utteranceRef.current = utter;
        synth.speak(utter);
        setSpeechStatus('playing');
        break;
        
      case 'playing':
        synth.pause();
        setSpeechStatus('paused');
        break;
        
      case 'paused':
        synth.resume();
        setSpeechStatus('playing');
        break;
    }
  };

  const stopSpeech = () => {
    const synth = window.speechSynthesis;
    synth.cancel();
    setSpeechStatus('stopped');
    utteranceRef.current = null;
  };

  // Limpiar al desmontar el componente
  useEffect(() => {
    return () => {
      const synth = window.speechSynthesis;
      synth.cancel();
      utteranceRef.current = null;
    };
  }, []);

  return (
    <>
      <IonHeader className='museo-ion-header'>
        <IonToolbar className='name-header-modal1 toolbar-modal-museo'>
          <IonButtons className='button-close'>
            <IonButton className='text-close-museo' onClick={() => onDismiss()}>
              <img src={closePage} alt="imageClose" id='icon-close' />
            </IonButton>
          </IonButtons>
          <Swiper
            modules={[Autoplay, Keyboard, Pagination, Scrollbar, Zoom, IonicSlides]}
            autoplay={true}
            keyboard={true}
            pagination={{
              dynamicBullets: true,
            }}
            scrollbar={true}
            zoom={true}
            slidesPerView={1}
            onSlideChange={() => console.log('slide change')}
            onSwiper={(swiper) => console.log(swiper)}
          >
            {marker.images.map((element, index) => (
              <SwiperSlide key={index}>
                <IonCard id='swiper-ioncard'>
                  <img className="img-swiper" alt={marker.nombre} src={element} onError={(e) => {
  e.currentTarget.onerror = null; 
  e.currentTarget.src = 'https://mexicoprofundo.app/fallback-imgs/collage-fallback.png';
}}
/>
                  <IonCardHeader>
                    <IonCardTitle>{marker.nombre}</IonCardTitle>
                  </IonCardHeader>
                </IonCard>
              </SwiperSlide>
            ))}
          </Swiper>
          <IonTitle>
            <div className="title">
              <div className="localidad">
                <div className="icon-loc">
                  <IonImg
                    src={location_white}
                    alt="Location_white"
                  ></IonImg>
                </div>
                <div className="lugar">
                  {marker.nombre}
                </div>
              </div>
            </div>
          </IonTitle>
        </IonToolbar>
      </IonHeader>
      <IonContent>
        <p></p>
        <IonGrid className='ion-padding'>
          <IonRow className='padimagen'>
            <IonCol size='2'>
              <img src={marker.icono} alt="Mas Información" id='icon-mxprof' />
            </IonCol>
            <IonCol size='8'>
              <IonLabel>
                <h1>{marker.nombreEstacion}</h1>
                <IonNote>{t("restaurant.open")}: {marker.horarios}</IonNote>
              </IonLabel>
            </IonCol>
            <IonCol size="2">
              <div className="speech-controls">
                <IonButton 
                  onClick={handleSpeech} 
                  size="large" 
                  fill="outline"
                  color={speechStatus !== 'stopped' ? 'primary' : 'medium'}
                >
                  <IonIcon icon={
                    speechStatus === 'stopped' ? volumeHighOutline : 
                    speechStatus === 'playing' ? pauseOutline : 
                    playOutline
                  } />
                </IonButton>
                
                {speechStatus !== 'stopped' && (
                  <IonButton 
                    onClick={stopSpeech} 
                    size="small" 
                    fill="solid"
                    color="danger"
                    className="stop-button"
                  >
                    <IonIcon icon={stopOutline} />
                  </IonButton>
                )}
              </div>
            </IonCol>
          </IonRow>

          <IonRow className='ion-margin-botton'>
            <IonCol size='12' >
              <IonLabel>
                <IonRow className='ion-align-items-center'>
                  <IonCol size="12">
                    <IonLabel>{marker.descripcion}</IonLabel>
                  </IonCol>
                </IonRow>
              </IonLabel>
              <IonRow content='center'>
                <IonButton fill="outline" size="small" className="simple-icon" id="click-trig">
                  <img src={mxproficon} alt="Mas Información" id='icon-mxprof' />
                </IonButton>
                <IonButton fill="outline" size="small" className="simple-icon" id="click-coop">
                  <img src={mxproficon} alt="Mas Información" id='icon-mxprof'/>
                </IonButton>
                <IonButton fill="outline" size="small" className="simple-icon" id="click-comi">
                  <img src={mxproficon} alt="Mas Información" id='icon-mxprof' />
                </IonButton>
                <IonButton fill="outline" size="small" className="simple-icon" id="click-arq">
                  <img src={mxproficon} alt="Mas Información" id='icon-mxprof' />
                </IonButton>
                <IonButton fill="outline" size="small" className="simple-icon" id="click-mus">
                  <img src={mxproficon} alt="Mas Información" id='icon-mxprof' />
                </IonButton>
              </IonRow>
              <IonPopover trigger="click-trig" triggerAction="click">
                <IonContent class="ion-padding">¿Sabías que en Yucatán y Quintana Roo se produce la miel melipona, usada desde la época maya con fines medicinales y rituales?</IonContent>
              </IonPopover>
              <IonPopover trigger="click-coop" triggerAction="click">
                <IonContent class="ion-padding">¿Sabías que los mayas de Yucatán desarrollaron uno de los calendarios más precisos del mundo antiguo, basado en la observación astronómica?</IonContent>
              </IonPopover>
              <IonPopover trigger="click-comi" triggerAction="click">
                <IonContent class="ion-padding">¿Sabías que muchos cenotes de Yucatán y Quintana Roo fueron considerados entradas al inframundo maya, conocido como Xibalbá?</IonContent>
              </IonPopover>
              <IonPopover trigger="click-arq" triggerAction="click">
                <IonContent class="ion-padding">¿Sabías que la lengua maya yucateca sigue siendo hablada por cientos de miles de personas y es una de las lenguas indígenas más vivas de México?</IonContent>
              </IonPopover>
              <IonPopover trigger="click-mus" triggerAction="click">
                <IonContent class="ion-padding">¿Sabías que en Quintana Roo ocurrió la Guerra de Castas, uno de los movimientos indígenas más importantes del siglo XIX en México?</IonContent>
              </IonPopover>
            </IonCol>
          </IonRow>

          <IonList className='Incluye'>
            <h3>{t("arqueologia.detalles")}</h3>
            <IonItem>
              <IonIcon icon={earth} color="success" slot="start"></IonIcon>
              <IonLabel>{t("arqueologia.tipo")}: {marker.direccion}</IonLabel>
            </IonItem>
            <IonItem>
              <IonIcon icon={alarmSharp} color="success" slot="start"></IonIcon>
              <IonLabel className="ion-text-wrap">{t("arqueologia.horario")}: {marker.horarios_de_trenes}</IonLabel>
            </IonItem>
            <IonItem>
              <IonIcon icon={linkSharp} color="success" slot="start"></IonIcon>
              <IonLabel className="ion-text-wrap">{marker.sitio_web}</IonLabel>
            </IonItem>
            <IonItem>
              <IonIcon icon={phonePortraitOutline} color="success" slot="start"></IonIcon>
              <IonLabel className="ion-text-wrap">{marker.telefono}</IonLabel>
            </IonItem>
            {/* Accesibilidad */}
            <IonItem>
              <IonIcon icon={accessibility} color="success" slot="start"></IonIcon>
              <IonLabel className="ion-text-wrap">{t("arqueologia.accesibilidad")}: {marker.accesibilidad}</IonLabel>
            </IonItem>

            {/* Instalaciones */}
            <IonItem>
              <IonIcon icon={construct} color="success" slot="start"></IonIcon>
              <IonLabel className="ion-text-wrap">{t("arqueologia.instalaciones")}: {marker.instalaciones}</IonLabel>
            </IonItem>
          </IonList>            
        </IonGrid>
      </IonContent>
    </>
  );
};

export default EstacionTrenModal;